import { render, staticRenderFns } from "./GlaNumber.vue?vue&type=template&id=1af3fd12&"
import script from "./GlaNumber.vue?vue&type=script&lang=js&"
export * from "./GlaNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports